import { render, staticRenderFns } from "./UserCounter.vue?vue&type=template&id=633e3529&scoped=true&"
import script from "./UserCounter.vue?vue&type=script&lang=js&"
export * from "./UserCounter.vue?vue&type=script&lang=js&"
import style0 from "./UserCounter.vue?vue&type=style&index=0&id=633e3529&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633e3529",
  null
  
)

export default component.exports